<template>
  <v-app>
    <!-- NAVBAR superior fijo -->
    <NavBar
      class="navbar"
      @updateNavBar="updateNavBar"
    />

    <!-- SIDEBAR permanente en escritorio y drawer en móvil -->
    <v-navigation-drawer
      v-if="!isMobile"
      app
      permanent
      class="sidebar"
    >
      <Sidebar :itemsMenu="itemsMenu" />
    </v-navigation-drawer>

    <v-navigation-drawer
      v-else
      v-model="drawerBar"
      temporary
      app
      @input="updateDrawerState"
      class="sidebar-mobile"
    >
      <Sidebar :itemsMenu="itemsMenu" />
    </v-navigation-drawer>

    <!-- CONTENIDO PRINCIPAL -->
    <v-main class="main-content">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>

    <!-- OVERLAY SI USUARIO ESTÁ INHABILITADO -->
    <v-overlay :z-index="zIndex" :value="overlay">
      <v-card elevation="2" shaped class="mx-auto my-5 pa-4 text-center">
        <v-row justify="center" align="center">
          <v-col cols="12">
            <strong>Usuario Inhabilitado</strong>
          </v-col>
        </v-row>
      </v-card>
    </v-overlay>
  </v-app>
</template>
<script>
import NavBar from "../../../components/navbar/NavBarMAyuda.vue";
import NavBarClinicas from "../../../components/navbar/NavBarClinicas.vue";
import Sidebar from "../../../components/sidebar/sidebar.vue";
import { mapState, mapActions } from "vuex";
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export const API_KEY_DNI = process.env.VUE_API_KEY_DNI;

export default {
    data() {
        return {
            isMobile:false,
            overlay: false,
            zIndex: 99,
            perfil: "",
            nombre: "",
            itemsMenu: [],
            idUsuario: null,
            system: "Mesa Ayuda",
            idSystem:null
        };
    },
    methods: {
        getIdSytem(){
            axios
                .get(RUTA_API + "/seguridad_system/obtener-id/?system=" + this.system)
                .then((res) => {
                    this.idSystem=res.data[0].id;
                    sessionStorage.setItem("idSystem", this.idSystem);
                    this.loadComponentes();
                })
                .catch((res) => {
                });
        },
        loadComponentes() {
           this.itemsMenu = [
           {
                "id": 12,
                "nombre": "Reportar Incidente",
                "descripcion": "Modulo que contiene los usuarios del sistema",
                "path": "/mesa_ayuda_cliente/reportar_incidente",
                "icon": "mdi mdi-account-group"
            },
            {
                "id": 15,
                "nombre": "Reserva de laptop",
                "descripcion": "Reservar laptop del parque informático",
                "path": "/mesa_ayuda_cliente/reserva_laptop",
                "icon": "mdi mdi-laptop"
            },
            {
                "id": 13,
                "nombre": "Historial tickets",
                "descripcion": "Modulo que contiene los usuarios del sistema",
                "path": "/mesa_ayuda_cliente/reporte_incidente",
                "icon": "mdi mdi-account-cog"
            }
           ]
        },
        estructurarComponentes(lista) {
            const mapa = {}; // Almacena los elementos por su ID
            const resultado = []; // Lista final con estructura jerárquica

            // Primero, se asignan los elementos al mapa usando su ID
            lista.forEach(item => {
                mapa[item.id] = { ...item, children: [] };
            });

            // Luego, se organizan en jerarquía según `padre_id`
            lista.forEach(item => {
                if (item.padre_id === 0) {
                    resultado.push(mapa[item.id]); // Es un nodo raíz
                } else if (mapa[item.padre_id]) {
                    mapa[item.padre_id].children.push(mapa[item.id]); // Se añade como hijo del padre
                }
            });

            // Remover `hijos` en elementos que no tengan hijos
            function limpiarHijos(obj) {
                if (obj.children.length === 0) {
                    delete obj.children; // Elimina el array si está vacío
                } else {
                    obj.children.forEach(limpiarHijos); // Llamada recursiva para limpiar los hijos
                }
            }
            resultado.forEach(limpiarHijos);

            return resultado;
        },
        updateNavBar(datos) {
            this.drawerBar = datos;
        },
        ...mapActions(["setDrawerBar"]),
        handleRouteChange() {
            this.setDrawerBar(false);
        },
        updateDrawerState(value) {
            this.setDrawerBar(value);
        },
    },
    computed: {
        ...mapState(["drawerBar"]),
    },
    mounted() { 
        this.getIdSytem();
    },
    created() {
        this.perfil = sessionStorage.getItem("perfil");
        this.nombre = sessionStorage.getItem("nombre");
        this.idUsuario = sessionStorage.getItem("idUsuario");
        this.$router.afterEach(() => {
            this.handleRouteChange();
        });
    },
    components: {
        NavBar,
        NavBarClinicas,
        Sidebar
    },
};
</script>
<style scoped>
::v-deep .v-list-item .v-list-item__title, .v-list--dense .v-list-item .v-list-item__subtitle {
    font-size: 0.87rem;
    font-weight: 300 !important;
    line-height: 1rem;
    letter-spacing: 0.02rem;
}
.v-navigation-drawer {
    width: 280px  !important;
    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.618);
}

::v-deep .el-form-item__label {
    margin-left: .2rem !important;
    line-height: 0px !important;
}
.v-icon.v-icon {
    color: rgb(255, 255, 255) !important
}

.theme--light.v-icon {
    color: rgb(255, 255, 255) !important;
}

a {
    text-decoration: none;
}

.v-divider.theme--light {
    border-color: rgba(255, 255, 255, 0.643);
}

a:hover {
    background-color: #ffffff10;
}

.v-list-item__title.text-h6,
.v-list-item__subtitle {
    color: white !important;
    text-decoration: none;
}

.v-list-item-navbar:hover {
    background-color: #ffffff10;
}

.v-list-item-navbar {
    margin: 0.5rem 0;
}

.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
    color: white !important;
    text-decoration: none;
}

.v-list-group {
    color: white !important;
}

.v-list-group__header :hover {
    background-color: #ffffff10;
}

.v-navigation-drawer {
    background: linear-gradient(135deg, #005dbe, #0062be, #005dc6) !important;
    color: white !important;
}
::v-deep.v-list-item--dense, .v-list--dense .v-list-item {
    height: 200px;
}

@media (max-width: 1024px) {
    .main-responsive {
        margin-left: 0rem;
        padding-left: 1.5rem;
    }
}

tbody tr td {
    font-size: 0.7rem;
}

.v-expansion-panel-header {
    padding: 0.5rem !important;
}

@media (max-width: 1024px) {
    .drawer-bar {
        display: none;
    }
}

/* Opcional: Mostrar el botón solo en pantallas mayores a 1024px (ej. desktops) */
@media (min-width: 1024px) {
    .drawer-bar {
        display: block;
    }
}

::v-deep .el-dialog,
.el-form,
.el-input,
.el-button,
.el-date-picker,
.el-table,.el-picker-panel__body {
  /* /*  font-family: 'Poppins', sans-serif !important; */
  font-family: "Roboto", sans-serif !important;
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  height: 64px; /* Altura del NavBar */
  z-index: 10;
}

.sidebar {
  background-color: #f8f8fb !important;
}

.sidebar-mobile {
  padding-top: 64px; /* Para que no tape el NavBar */
  background-color: #f8f8fb !important;
}

.main-content {
    padding-left: 24px !important;
  margin-top: 64px; /* Espacio debajo del NavBar */
  background-color: #f8f8fb;
  min-height: calc(100vh - 64px);
}
</style>